import React from 'react';
import {Grid} from "@mui/material";
import Kibor from "./Kibor";
import {ConstantsContext} from "../../../contexts/ConstantsContext";

function ConstantsList(props) {

    const constantsContext = React.useContext(ConstantsContext);
    const { constants, setConstants } = constantsContext

    return (
        <Grid container spacing={4} mt={-2}>
            <Kibor kiborRate={constants.kiborRate} update={(value) => setConstants({...constants, kiborRate: value})}/>
        </Grid>
    );
}

export default ConstantsList;